import { Text } from '@ps-design-system/components/Text';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProductionRuleItem = ({ label, description }) => {
  return (
    <div>
      <Text element="p" typeface="body-2-m" style={{ margin: '0' }}>
        {label}
      </Text>
      {description && (
        <Text element="p" style={{ margin: '0', color: '#6A6E7A' }}>
          {description}
        </Text>
      )}
    </div>
  );
};
ProductionRuleItem.propTypes = {
  label: PropTypes.node,
  description: PropTypes.node
};

export const ProductionRules = ({ productionDetails }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
      }}
    >
      <ProductionRuleItem
        label={
          productionDetails?.requires_production_insurance ? (
            <FormattedMessage
              id="production_rules.insurance_is_required"
              defaultMessage="Production insurance is required"
            />
          ) : (
            <FormattedMessage
              id="production_rules.insurance_not_required"
              defaultMessage="Production insurance is not required"
            />
          )
        }
        description={productionDetails?.insurance_requirement_description}
      />

      <ProductionRuleItem
        label={
          productionDetails?.can_move_furniture ? (
            <FormattedMessage
              id="production_rules.furniture_can_be_moved"
              defaultMessage="Furniture and decorations may be moved"
            />
          ) : (
            <FormattedMessage
              id="production_rules.furniture_cannot_be_moved"
              defaultMessage="No moving furniture and decorations"
            />
          )
        }
        description={productionDetails?.furniture_move_description}
      />

      <ProductionRuleItem
        label={
          productionDetails?.can_use_smoke_machines ? (
            <FormattedMessage
              id="production_rules.smoke_machines_allowed"
              defaultMessage="Smoke machines are allowed"
            />
          ) : (
            <FormattedMessage
              id="production_rules.no_smoke_machines_allowed"
              defaultMessage="No smoke machines allowed"
            />
          )
        }
      />

      <ProductionRuleItem
        label={
          productionDetails?.can_use_smoke_machines ? (
            <FormattedMessage
              id="production_rules.nudity_allowed"
              defaultMessage="Nudity is allowed"
            />
          ) : (
            <FormattedMessage
              id="production_rules.no_nudity_allowed"
              defaultMessage="No nudity allowed"
            />
          )
        }
      />
    </div>
  );
};

ProductionRules.displayName = 'ProductionRules';
ProductionRules.propTypes = {
  productionDetails: PropTypes.object,
  minAge: PropTypes.number,
  intl: PropTypes.object
};
